import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function ProductReveal() {
  return <section className="bg-navy-dark py-8 md:py-24 px-4 relative" data-id="element-81">
      <div className="max-w-4xl mx-auto text-center" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-83">
          <div className="bg-navy-light p-4 md:p-6 rounded-xl md:rounded-2xl border border-gold/30 mb-4 md:mb-6 text-center" data-id="element-84">
            <p className="text-xl md:text-3xl font-black text-white" data-id="element-85">
              📚 4 tomos y 3 bonus con un total de{' '}
              <span className="text-gold" data-id="element-86">+300 páginas</span>
            </p>
          </div>

          <div className="bg-navy-light p-5 md:p-12 rounded-xl md:rounded-2xl border border-gold/20 mb-8 md:mb-12 text-left" data-id="element-87">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-5 md:mb-8 text-center" data-id="element-88">
              ¿Qué incluye?
            </h3>
            <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-89">
              <div className="flex items-start gap-2" data-id="element-90">
                <span className="text-gold text-lg mt-0.5" data-id="element-91">✔</span>
                <span className="text-white font-medium text-base md:text-lg" data-id="element-92">
                  Plantillas listas para usar
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-93">
                <span className="text-gold text-lg mt-0.5" data-id="element-94">✔</span>
                <span className="text-white font-medium text-base md:text-lg" data-id="element-95">
                  Sistema de seguimiento de clientes
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-96">
                <span className="text-gold text-lg mt-0.5" data-id="element-97">✔</span>
                <span className="text-white font-medium text-base md:text-lg" data-id="element-98">
                  Organización clara de casos
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-99">
                <span className="text-gold text-lg mt-0.5" data-id="element-100">✔</span>
                <span className="text-white font-medium text-base md:text-lg" data-id="element-101">
                  Estructura profesional del estudio
                </span>
              </div>
            </div>

            <div className="mt-6 md:mt-10 text-center space-y-2 md:space-y-4 text-gray-300 text-sm md:text-base" data-id="element-102">
              <p data-id="element-103">Todo diseñado para que lo implementes rápido.</p>
              <p className="font-bold text-white" data-id="element-104">
                Sin perder horas aprendiendo.
              </p>
            </div>
          </div>

          <CTAButton data-id="element-105" />
        </motion.div>
      </div>
    </section>;
}